import React from 'react';
import DashboardListPageContainer from './DashboardListPageContainer';

export class DashboardListPage extends React.Component{
    
    render(){
      return (
        <DashboardListPageContainer {...this.props}/>
      )
    }
}


